import { useEffect, useState } from 'react';
import { isFeatureEnabled } from 'helpers/featureFlags';

// Returns `{ enabled, loading }`. Starts disabled so a gated feature never
// flashes on screen before the flags have loaded.
export default function useFeatureFlag(name) {
    const [state, setState] = useState({ enabled: false, loading: true });

    useEffect(() => {
        let cancelled = false;
        isFeatureEnabled(name)
            .then(enabled => { if (!cancelled) setState({ enabled, loading: false }); })
            .catch(() => { if (!cancelled) setState({ enabled: false, loading: false }); });
        return () => { cancelled = true; };
    }, [name]);

    return state;
}
